// Importa solo los módulos necesarios de Firebase v9
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { firebaseApp } from "../../utils/FirebaseConfig";

const firestore = getFirestore(firebaseApp);

// Funciones actualizadas utilizando Firebase v9
export const frequentQuestions = async () => {
  const configuration = await getDoc(
    doc(firestore, "configuration", "questions")
  );
  const answer = configuration.data().questions;

  console.log(answer, "REspuestaaa");
  return answer;
};

export const maintain = async () => {
  const configuration = await getDoc(
    doc(firestore, "Pantallas", "error_validate_app_in_maintenance")
  );
  const answer = configuration.data().result;
  return answer;
};

export const carousel = async () => {
  const configuration = await getDoc(
    doc(firestore, "configuration", "carousel", "1", "lanzamiento")
  );
  const answer = configuration.data();
  return answer;
};

export const calculator = async () => {
  const configuration = await getDoc(
    doc(firestore, "configuration", "payments")
  );
  const answer = configuration.data().minimum;
  return answer;
};

export const termsandconditions = async () => {
  const configuration = await getDoc(
    doc(firestore, "configuration", "termsOfServiceCdmx")
  );
  const answer = configuration.data().TermsAndConditions;
  return answer;
};

export const announcementPrivacy = async () => {
  const configuration = await getDoc(
    doc(firestore, "configuration", "termsOfServiceCdmx")
  );
  const answer = configuration.data().NoticeOfPrivacy;
  return answer;
};
